import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { OfferStatus } from "@/hooks/use-offers";

const LABELS: Record<OfferStatus, string> = {
  draft: "Utkast",
  sent: "Sendt",
  accepted: "Akseptert",
  lost: "Tapt",
};

const STYLES: Record<OfferStatus, string> = {
  draft: "bg-muted text-muted-foreground",
  sent: "bg-blue-100 text-blue-700",
  accepted: "bg-emerald-100 text-emerald-700",
  lost: "bg-red-100 text-red-700",
};

export function OfferStatusBadge({ status }: { status: OfferStatus }) {
  return (
    <Badge variant="secondary" className={cn("text-xs", STYLES[status])}>
      {LABELS[status]}
    </Badge>
  );
}
